import React, { useEffect } from 'react';
import './App.css';
import Lenis from 'lenis';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import Gallery from './components/Gallery';
import Booking from './components/Booking';
import Location from './components/Location';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import MobileBottomBar from './components/MobileBottomBar';

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-black min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Features />
      <Gallery />
      <Booking />
      <Location />
      <Footer />
      <FloatingButtons />
      <MobileBottomBar />
    </div>
  );
}

export default App;
